import React, { useState, useEffect } from 'react'
import { Modal, Form, InputNumber, App } from 'antd'
import { useFeiyongCWCHMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
import dayjs from 'dayjs'
function ExpenseFinanceAmount(props) {
  const { message } = App.useApp()
  const [open, setOpen] = useState(false)
  const [info, setInfo] = useState({
    fy_id:props.fy_id,
    fy_state: props.fy_state,
    fy_cw_content:'',
    fy_amount:props.fy_amount,
  })
  const [form] = Form.useForm()
  const [updateSave] = useFeiyongCWCHMutation()
  useEffect(() => {
    form.setFieldsValue({
        fy_id:props.fy_id,
        fy_state: props.fy_state,
        fy_cw_content:'',
        fy_amount:props.fy_amount,
    })
  }, [props.fy_id, props.fy_state, props.fy_amount, form])
  return (
    <>
        <Icon type='financeAmount' onClick={() => setOpen(true)} />
        <Modal
            title='财务改金额'
            open={open}
            onCancel={() => setOpen(false)}
            onOk={() => {
                updateSave({
                    fy_id:props.fy_id,
                    fy_state: props.fy_state,
                    fy_cw_content:props.fy_cw_content+`！${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：财务改金额，原始价格为${props.fy_amount}`,
                    fy_amount:info.fy_amount,
                }).then((res) => {
                    if(res.data.Status === 'success') {
                        message.success('财务改金额成功！')
                        setOpen(false)
                    } else {
                        message.error('财务改金额失败！'+res.data.Message)
                    }
                }).catch((err) => {
                    message.error('财务改金额失败！'+err.message)
                })
            }}
        >
            <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                <Form.Item label='金额' name='fy_amount' rules={[{ required: true, message: '请输入金额' }]}>
                    <InputNumber 
                        min={0.01} 
                        max={99999999.99} 
                        step={0.01} 
                        onChange={(value) => {
                            setInfo(prev => ({ ...prev, fy_amount: value }))
                        }}
                        style={{ width: '100%' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    </>
  )
}


    export default ExpenseFinanceAmount